import { getProductJson, getSelectedVariantByIdJson, getVariantsByColor } from './helpers';
import { getSizedImageURL, preloadImages } from '../../core/images';

const generateImageTag = (image, size, size_zoom = 'master', lazyload = false, zoom = false, zoom_modal = false, responsive = false, image_index = 0) => {
  const image_src = image.src;
  const img_sized = getSizedImageURL(image_src, size);
  const src_html = (lazyload) ? `loading="lazy" src="${img_sized}"` : `src="${img_sized}"`;
  const zoom_html = (zoom) ? `data-zoom="${getSizedImageURL(image_src, size_zoom)}"` : '';
  const zoom_in_modal = (zoom_modal) ? 'data-modal="#zoom-modal"' : '';
  const img_alt = (image.alt === null || image.alt === '') ? $('.product-details__title').text() : image.alt;

  /*
  // Pull the images from the media array to get the alt defined in the admin
  const product_json = getProductJson();
  if (product_json.media.length) {
    const matching_media = _.find(product_json.media, { src: `https:${image_src}` });
    if (typeof matching_media !== 'undefined' && matching_media.alt !== '') {
      if (image_index > 0) {
        img_alt = `Photo ${image_index}: ${matching_media.alt}`;
      }
    }
  }
  */
  
  if (responsive) {
    return `
    <div class="product-main" data-product-main tabindex="-1">
      <img
      loading="lazy"
      alt="${img_alt}"
      sizes="(min-width: ${size.replace('x', 'px')}), 100vw"
      data-srcset="${getSizedImageURL(image_src, '500x')} 500w,
        ${getSizedImageURL(image_src, '800x')} 800w,
        ${getSizedImageURL(image_src, '1024x')} 1024w,
        ${getSizedImageURL(image_src, '1280x')} 1280w,
        ${getSizedImageURL(image_src, '1600x')} 1600w,
        ${getSizedImageURL(image_src, '2000x')} 2000w"
      src="${img_sized}"
      ${zoom_html}
      ${zoom_in_modal} />
    </div>`;
  } else {
    return `
    <div class="product-main" data-product-main tabindex="-1">
      <img loading="lazy" class="product-main__image" ${src_html} ${zoom_html} ${zoom_in_modal} alt="${img_alt}" tabindex="-1" alt="${img_alt}" />
    </div>`;
  }
};

const getFirstImageIndexFromSelectedColor = (selected_color) => {
  let featured_images = _.map(getVariantsByColor(selected_color), 'featured_image');

  // Remove false, null, 0, "", undefined, and NaN
  // The same images should be in this array
  featured_images = _.compact(featured_images);

  // No assigned image to the variants (shouldn't be happening!)
  if (featured_images.length === 0) {
    featured_images.push({ src: getProductJson().featured_image });
  }

  // Cached data has https but not the storefront API data
  return _.findIndex(getProductJson().images, (obj) => { return `https:${obj}` === featured_images[0].src || obj === featured_images[0].src; });
};

const getLastImageIndexFromSelectedColor = (selected_color, all_images) => {
  // Find next color
  const next_color_index = $('[data-product-option-color].color-swatch.active').index() + 1;
  let next_color_first_image_index = null;

  if (next_color_index > $('[data-product-option-color].color-swatch').length - 1) {
    next_color_first_image_index = all_images.length;
  } else {
    const next_color = $($('[data-product-option-color].color-swatch').get(next_color_index)).data('color-value');
    next_color_first_image_index = getFirstImageIndexFromSelectedColor(next_color);
    // console.log('next_color_index', next_color_index, next_color);
  }

  return next_color_first_image_index - 1;
};

// Extract the variant images only
export default () => {
  if (!$('.product-overview-v3').length || !$('[data-product-json]').length || (!$('[data-option-color]').length && !$('[data-single-option-selector]').length)) {
    return false;
  }

  // Get all images from the product
  const all_images = _.filter(getProductJson().media, { media_type: 'image'});
  // const all_images = getProductJson().images;
  const color_index = $('[data-option-color]').data('option-index');
  const selected_variant = getSelectedVariantByIdJson();
  let first_image_index = 0;
  let last_image_index = all_images.length - 1;

  if ($('[data-single-option-selector]').length) {
    // find 1st and last image
  } else {
    const selected_color = selected_variant.options[color_index];
    first_image_index = getFirstImageIndexFromSelectedColor(selected_color);
    last_image_index = getLastImageIndexFromSelectedColor(selected_color, all_images);
  }

  // We assigned the main featured image in getFirstImageIndexFromSelectedColor()
  if (first_image_index === -1) {
    first_image_index = 0;
  }

  if (last_image_index < first_image_index) {
    last_image_index = first_image_index;
  }

  const variant_images = all_images.slice(first_image_index, last_image_index + 1);

  let first_image = '';
  let thumb_images = '';
  const max_thumbs = 6;
  const thumbs_urls = [];
  const full_urls = [];
  const zoom_urls = [];
  const alt_images = [];
  let mobile_images_html = '';

  let i = 1;
  _.each(variant_images, (image) => {
    // Using responsive doesn't work with the preload because we don't know the size that needs to be preloaded
    if (i === 1) {
      first_image = generateImageTag(image, '1200x', '4000x', false, true, true, false, i);
    }
    
    thumbs_urls.push(getSizedImageURL(image.src, '220x'));
    full_urls.push(getSizedImageURL(image.src, '1200x'));
    zoom_urls.push(getSizedImageURL(image.src, '4000x'));
    alt_images.push((image.alt === null || image.alt === '') ? $('.product-details__title').text() : image.alt);

    mobile_images_html += generateImageTag(image, '1200x', '4000x', false, true, true, false, i);
    i++;
  });

  $('[data-product-full]').html(first_image);

  thumb_images = thumbs_urls.map((thumb, index) => {
    return `
      <div role="button" aria-controls="slide-${index + 1}" aria-selected="false" class="product-images__thumb" id="control-slide-${index + 1}" role="tab" type="button" tabindex="-1" data-product-thumb data-product-full-url="${full_urls[index]}" data-product-zoom-url="${zoom_urls[index]}">
        <img src="${thumb}" class="product-images__thumb-image" width="110" alt="${alt_images[index]} - Thumbnail #${index + 1}" />
      </div>
    `;
  });
  thumb_images = thumb_images.slice(0, max_thumbs);
  $('[data-product-thumbs]').html(thumb_images);

  // Mobile images
  const mobile_images_container = document.querySelector('[data-product-mobile-images]');

  if (mobile_images_container) {
    mobile_images_container.classList.remove('single-image');
    mobile_images_container.innerHTML = mobile_images_html;

    // Single image full width on mobile
    if (i - 1 === 1) {
      mobile_images_container.classList.add('single-image');
    }
  }
};
